import AuthStore from './AuthStore'
import PaymentStore from './PaymentStore'
import LocaleStore from './LocaleStore'

export default {
  authStore: new AuthStore(),
  paymentStore: new PaymentStore(),
  localeStore: new LocaleStore()
}
